import type { JSX, ReactNode } from 'react';
import cx from 'clsx';

import '#stylesheets/components/AppHeader.css';

type AppHeaderProps = {
  breadcrumbs?: ReactNode;
  className?: string;
  children: ReactNode;
  hasDescription?: boolean;
  isSeamless?: boolean;
};

export function AppHeader(props: AppHeaderProps) {
  const { breadcrumbs, className, children, hasDescription, isSeamless = false } = props;
  const classes = cx(isSeamless ? 'AppHeader--seamless' : 'AppHeader', className, {
    'AppHeader--hasDescription': hasDescription && !breadcrumbs,
  });
  const shouldRenderTopline = Boolean(props.breadcrumbs);

  return (
    <header className={classes}>
      {shouldRenderTopline && <div className="AppHeader-topline">{breadcrumbs}</div>}
      <div
        className={cx('AppHeader-main', { 'AppHeader-main--hasDescription': hasDescription })}
        data-test-id="app-header"
      >
        {children}
      </div>
    </header>
  );
}

export type SimpleAppHeaderProps = {
  description?: string | JSX.Element;
  className?: string;
};

export function SimpleAppHeader(props: SimpleAppHeaderProps) {
  const { description, className } = props;
  return (
    <AppHeader hasDescription={!!description} className={className} isSeamless>
      {description && <p>{description}</p>}
    </AppHeader>
  );
}
